import React from "react";
import Router from "./routes/Router";
import withClearCache from "./hoc/WithClearCache";
import WithAuthentication from "../src/Authentication/WithAuthentication";

const ClearCacheComponent = withClearCache(MainApp);
function App() {
  return <ClearCacheComponent />;
}
function MainApp() {
  return (
    <div className="App">
      {/* <WithAuthentication> */}
      <Router />
      {/* </WithAuthentication> */}
    </div>
  );
}

export default App;
